import React from 'react';
import '../styles/NotFound.css';

export default function NotFound() {
  return (
    <div className="not-found-container">
      <h1>404</h1>
      <h2>Página não encontrada</h2>
      <p>A página que você está procurando não existe ou foi movida.</p>
      <a href="/">Voltar para a página inicial</a>
    </div>
  );
}
